import React from 'react'
import PropTypes from 'prop-types'
import IdentityVerificationForm from './IdentityVerificationForm'
import withOnboardingSection from 'components/Onboarding/withOnboardingSection'
import { mapIdentityVerificationValues } from 'utils/formDataMapping'
import { updateProspect } from 'utils/apiRequest'

const Section = withOnboardingSection(IdentityVerificationForm)

const prevPageInfo = {
  name: 'Personal Information',
  to: '/onboarding/account_holder/personal_information',
  showBackWord: true
}

const submitAction = (formData) => {
  const submitData = {
    ...formData,
    reviewedIdentityVerification: true,
  }
  return updateProspect(submitData)
}

const IdentityVerification = (props) => {
  const {
    goOnboardingEmploymentDetails,
    hide,
    prospect,
    setProspect,
    isLoading,
    isMobile
  } = props

  return (
    <Section
      formName="Identity Verification"
      description={['Next, we need to validate some identification details.']}
      goNextSection={goOnboardingEmploymentDetails}
      hide={hide}
      isMobile={isMobile}
      mapValues={mapIdentityVerificationValues}
      data={prospect}
      prevPageInfo={prevPageInfo}
      setData={setProspect}
      isLoading={isLoading}
      submitAction={submitAction}
      isProspect={true} />
  )
}

IdentityVerification.defaultProps = {
  isMobile: false
}

IdentityVerification.propTypes = {
  goOnboardingEmploymentDetails: PropTypes.func.isRequired,
  hide: PropTypes.bool.isRequired,
  prospect: PropTypes.object.isRequired,
  setProspect: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool
}

export default IdentityVerification



// WEBPACK FOOTER //
// ./src/components/Onboarding/IdentityVerification/IdentityVerification.jsx